import React from "react";
import PropTypes from "prop-types";

import FormSubmitButton from "./FormSubmitButton";
import FormInfo from "./FormInfo";
import FullScreenLoader from "../FullScreenLoader";
import { FormMode } from "../../types/enums";

const Form = (props) => (
  <form onSubmit={props.mode !== FormMode.VIEW ? props.onSubmit : null}>
    <fieldset disabled={props.isFetching || props.mode === FormMode.VIEW}>
      {props.children}
      <br />
      <FormInfo
        successMessage={props.successMessage}
        errorMessage={props.errorMessage}
      />
      {props.onSubmit && (
        <FormSubmitButton disabled={props.disabled || props.isFetching}>
          {props.submitText}
        </FormSubmitButton>
      )}
    </fieldset>
    {props.isFetching && <FullScreenLoader />}
  </form>
);

Form.propTypes = {
  mode: PropTypes.oneOf(Object.values(FormMode)),
  onSubmit: PropTypes.func,
  disabled: PropTypes.bool,
  isFetching: PropTypes.bool,
  children: PropTypes.node,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  submitText: PropTypes.string,
};

export default Form;



// WEBPACK FOOTER //
// ./src/components/forms/Form.js